/* eslint-disable react/no-unused-prop-types */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { createStyles, makeStyles } from "@material-ui/core";
import { Bagde, OrderCard } from "components/Card";
import { JobContext } from "contexts/JobContext";
import { RecapView } from "domains/Parcel/components/Details/NewOrderDetails";
import { Job, Order } from "generated/graphql";
import React from "react";
import "styled-components/macro";
import { useJobDetails, ViewArticles } from "./JobRightSideUtils";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      paddingTop: "28px",
      " @media(max-width: 1279px)": {
        paddingLeft: "40px",
      },
    },
    warningDiv: {
      width: "24px",
      height: "24px",
      opacity: 0.85,
      borderRadius: "50%",
      display: "flex",
      justifyContent: "center",
      position: "relative",
      left: "5px",
      top: "25px",
    },
    orderStyle: {
      fontSize: "14px",
      fontWeight: "bold",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
    receiverStyle: {
      fontSize: "14px",
      fontWeight: 600,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
      color: "#707070",
      display: "flex",
      justifyContent: "space-between",
    },
    address: {
      fontSize: "14px",
      fontWeight: 300,
      fontStretch: "normal",
      fontStyle: "italic",
      lineHeight: "normal",
      letterSpacing: "normal",
      color: "#707070",
    },
  })
);
export interface OrderViewProps {
  styles?: any;
  order?: Order;
  warning?: boolean;
  background?: string;
  leftBarreColor?: string;
  onClickOrderView?: (order: Order) => void;
}

export const OrderView = ({
  styles,
  order,
  warning = false,
  background = "#fff",
  leftBarreColor = "#399ebf",
  onClickOrderView,
}: OrderViewProps) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div
        css={`
          background-color: ${warning ? "#FFE7E7" : background};
        `}
        className={classes.warningDiv}
      >
        <div
          style={{
            marginBottom: "auto",
            marginTop: "auto",
          }}
        >
          <Bagde value="" variante="contained" height={10} width={10} color={warning ? "#F47F7F" : leftBarreColor} />
        </div>
      </div>
      <div
        css={`
          position: relative;
          right: -30px;
        `}
      >
        <OrderCard
          noBox
          elevation={0}
          height={90}
          width={235}
          warning={warning}
          style={{
            background: background ?? "#fff",
            height: 90,
            width: 290,
          }}
          leftBarreColor={leftBarreColor}
        >
          <div className={styles.car}>
            <div
              css={`
                color: ${warning ? "#F47F7F" : leftBarreColor};
              `}
              className={classes.orderStyle}
            >
              Order
            </div>
            <div className={classes.receiverStyle}>
              <div style={{ padding: "5px 5px 5px 0px" }}>
                {order?.order_receiver?.receiver_lastname} {order?.order_receiver?.receiver_firstname}
              </div>
              <ViewArticles color={leftBarreColor} onClick={() => onClickOrderView(order)}>
                {" "}
                {order?.order_parcels?.length || "?"} articles
              </ViewArticles>
            </div>
            <div className={classes.address}>{order?.order_receiver?.receiver_address?.address}</div>
          </div>
        </OrderCard>
      </div>
    </div>
  );
};

interface JobRightSideProps {
  orders?: Order[];
  showReloadButton?: boolean;
}
export function JobRightSide({ orders, showReloadButton = false }: JobRightSideProps) {
  const styles = useJobDetails();

  return (
    <div className={showReloadButton ? styles.root1 : styles.root}>
      <div className={showReloadButton ? styles.orderDisplay1 : styles.notShow}>
        {orders &&
          orders.map((order: Order, index: number) => (
            // eslint-disable-next-line react/no-array-index-key
            <RecapView order={order} />
          ))}
      </div>
    </div>
  );
}